import api from "../../../../lib/api";
import { IEditVasTypePayload, IVasTypeCreate, IVasTypeListSearch } from "../../../../types/master/vasTypeInterface";

export const createVasTypeApi = async (data: IVasTypeCreate) => {
  return await api.post("/vas-types/", data);
};

export const getVasTypeListApi = async (data: IVasTypeListSearch) => {
  return await api.get(`/vas-types/${data.page}/${data?.pageLimit ?? 10}`, {
    params: {
      search: data?.search ?? "",
    },
  });
};

export const getVasTypeDataByIdApi = async (id: number | string) => {
  return await api.get(`/vas-types/id/${id}`);
};

export const editVasTypeDataByIdApi = async (payload: IEditVasTypePayload) => {
  return await api.put(`/vas-types/id/${payload.id}`, payload.data);
};
